var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-wrap',{staticClass:"page-content content-detail-page",attrs:{"loading":_vm.isLoading,"error-obj":_vm.errorObj}},[_c('column-after-buy',{attrs:{"contentInfo":_vm.contentInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }